export class EnvironmentFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<Environment>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<Environment>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EnvironmentFilters.attributeTypeMap;
    }
    constructor() {
    }
}
